<template>
  <div class="custom-list-wrapper">
    <div class="row">
      <div class="col">
        <span class="custom-label">Key</span>
      </div>
      <div class="col-3">
        <span class="custom-label">Last Modified</span>
      </div>
      <div class="col-2 text-right">
        <span class="custom-label">Size</span>
      </div>
    </div>
    <ul class="custom-list">
      <li v-for="(item, idx) of contents" :key="idx">
        <div class="row">
          <div class="col">
            <a href="#" @click="getContents(item)">{{ item.key }}</a>
          </div>
          <div class="col-3">
            <span class="text-center">{{ formatDate(item.lastModified) }}</span>
          </div>
          <div class="col-2 text-right">
            <span class="text-right">{{ item.size }}</span>
          </div>
        </div>
      </li>
      <li v-if="isContinue">
        <div class="row">
          <div class="col text-center">
            <a href="#" @click="getMore">Continue</a>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { wasabiStore } from '@/stores/wasabi'
import globals from '@/plugins/globals'
export default {
  name: 'BucketContents',
  emits: ['get-more', 'get-item'],
  computed: {
    ...mapState(wasabiStore, ['account', 'bucket', 'contents', 'continuationToken']),
    isContinue() {
      return this.continuationToken !== null && this.continuationToken !== 'paginate'
    }
  },
  methods: {
    ...mapActions(wasabiStore, ['getPresignedUrl']),
    formatDate(date, type = 'datetime') {
      return globals.formatDate(date, type)
    },
    getMore() {
      this.$emit('get-more')
    },
    async getContents(item) {
      this.$emit('get-item', item)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-list-wrapper {
  margin-top: 10px;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 450px;
}
.custom-list {
  padding: 0;
  list-style-type: none;
  li {
    padding: 5px;
  }
  li:hover {
    background-color: rgb(219, 219, 219);
    cursor: pointer;
  }
  a {
    text-decoration: none;
    margin-top: 5px;
    margin-bottom: 5px;
  }
}
.custom-label {
  font-weight: 500;
}
</style>
